import { render } from "./Billboard.vue?vue&type=template&id=720a0d74&scoped=true"
import script from "./Billboard.vue?vue&type=script&lang=js"
export * from "./Billboard.vue?vue&type=script&lang=js"

import "./Billboard.vue?vue&type=style&index=0&id=720a0d74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720a0d74"]])

export default __exports__